var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SplitPaneIcon_styled_1 = require("./SplitPaneIcon_styled");
var SplitPaneIcon = /** @class */ (function (_super) {
    __extends(SplitPaneIcon, _super);
    function SplitPaneIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SplitPaneIcon.prototype.render = function () {
        return (React.createElement(SplitPaneIcon_styled_1.Container, __assign({}, this.props),
            React.createElement(SplitPaneIcon_styled_1.Icon, { axis: this.props.axis },
                React.createElement(SplitPaneIcon_styled_1.Part, { side: "left" }),
                React.createElement(SplitPaneIcon_styled_1.Line, null),
                React.createElement(SplitPaneIcon_styled_1.Part, { side: "right" }))));
    };
    return SplitPaneIcon;
}(React.Component));
exports.default = SplitPaneIcon;
